import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './commonComponents/Header/Header.Component';
import Footer from './commonComponents/Footer/Footer';
import Home from './components/Home/Home.Component';
import About from './components/About/About.Component';
import Download from './components/Download/Download.Component';
import Docs from './components/Docs/Docs.Component';
import Demo from './components/Demo/Demo.Component';
import Changelog from './components/Changelog/Changelog';
import PostManComparison from './components/Blog/PostmanCompare.Component'; 
import { ThemeProvider, createTheme } from '@mui/material/styles';
import SupportPage from './components/Support/Support.Component';
import Terms from './components/Terms/Terms.Component';
import PrivacyPolicy from './components/Privacy/Privacy.Component';
import { useMemo } from 'react';

const App = () => {
  const theme = useMemo(() => createTheme({
    palette: {
      mode: 'light',
    },
  }), []);
  return (
    <ThemeProvider theme={theme}>
      <Router>

        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/download" element={<Download />} />
          <Route path="/docs/*" element={<Docs />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/blog/hawkclient-vs-postman" element={<PostManComparison />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />

      </Router>
    </ThemeProvider>
  );
};

export default App;
